import * as React from 'react';
import { useNavigate } from 'react-router-dom';

import { AuthContext } from '../../AuthContext';
import { Container, Content, BottomBar } from '../../modules';
import { ListLogs } from './ListLogs';
import { Log } from '../../resource';

const LogList = () => {
  const auth = React.useContext(AuthContext);
  const navigate = useNavigate();

  const handleClick = (item: Log) => {
    // Pluralize the item type. Special pluralization rules apply.
    const plural = item.type.endsWith('y') ? item.type.slice(0, -1) + 'ies' : item.type + 's';
    navigate(`/${plural.toLowerCase()}/${item.object_id}`);
  }

  return (
    <Container>
      <Content>
        <ListLogs auth={auth} name="logs" onClick={handleClick}/>
      </Content>
      <BottomBar>
      </BottomBar>
    </Container>
  )
}

export { LogList }
